var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tool-text",style:(_vm.eleStyle)},[_c('div',{staticClass:"text-val"},[_c('pre',[_vm._v(_vm._s(_vm.media.ext_val_content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }